(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.Calculators",
            {
                url: "/Calculators",
                component: "calculators",
                PageTitle: "Calculators",
                requiredPermissions: "Calculators:View"                                           
            });
        }
    ]);

    app.component("calculators",
    {
        templateUrl: "App/Tools/Calculators/Calculators.html",
        controller: calculatorsCtrl
       
    });

    calculatorsCtrl.$inject = ["amplitudeService", "$scope","ssoApi", "externalLoading", "permissionService"];

    function calculatorsCtrl(amplitudeService, $scope, ssoApi, externalLoading, permissionService) {

        var $ctrl = this;

        var init = function() {
            $ctrl.ipipelineAccess = permissionService.hasAllPermissions("IpipelineFormsQuotesLife:Access");
            $ctrl.showCalcMenu = false;
        };

        init();

        $ctrl.dinkyTownCalculators = [
            {
                name: "U.S. 1040EZ Tax Estimator",
                url: "/DinkyTown/TaxEZ1040.html",
                category: "Taxes",
                description:
                    "Many people can use the 1040EZ tax form instead of the more complicated 1040 to calculate their taxes. Containing only seven required inputs, the 1040EZ is one of the quickest forms to calculate your tax bill."
            },
            {
                name: "Savings Goals",
                url: "/DinkyTown/Savings.html",
                category: "Savings",
                description:
                    "What will it take to reach your savings goal? This financial calculator helps you find out."
            },
            {
                name: "Savings, Taxes & Inflation",
                url: "/DinkyTown/SavingsVariables.html",
                category: "Savings",
                description:
                    "Use this calculator to determine how much your savings will be worth with these two important variables in mind."
            },
            {
                name: "Net Worth",
                url: "/DinkyTown/NetWorth.html",
                category: "Finance",
                description:
                    "This calculator helps you determine your net worth. It also estimates how your net worth could grow (or shrink!) over the next ten years."
            },
            {
                name: "Investment Returns",
                url: "/DinkyTown/InvestmentReturn.html",
                category: "Investments",
                description:
                    "There is more to investing than knowing your annual rate of return. Use this calculator to help you see how inflation, taxes and your time horizon can impact your bottom line."
            },
            {
                name: "72(t)",
                url: "/DinkyTown/Retire72T.html",
                category: "Retirement",
                description:
                    "The IRS Rule 72T allows for penalty free, early withdrawals from retirement accounts. Use this calculator to determine your allowable 72T Distribution and how it can help fund your early retirement."
            },
            {
                name: "Retirement Income",
                url: "/DinkyTown/RetirementIncome.html",
                category: "Retirement",
                description:
                    "Use this calculator to determine how much monthly income your retirement savings may provide you in your retirement."
            },
            {
                name: "Retirement Planner",
                url: "/DinkyTown/RetirementPlan.html",
                category: "Retirement",
                description: "Quickly determine if your retirement plan is on track - and learn how to keep it there."
            },
            {
                name: "RMD & Stretch IRA",
                url: "/DinkyTown/StretchIRA.html",
                category: "Retirement",
                description:
                    "Use this calculator to help determine how you can stretch out your retirement plan distributions for as long as possible."
            },
            {
                name: "Roth IRA",
                url: "/DinkyTown/RothIRA.html",
                category: "Retirement",
                description: "Use this calculator to compare the Roth IRA to an ordinary taxable investment."
            },
            {
                name: "Roth IRA Conversion",
                url: "/DinkyTown/RothTransfer.html",
                category: "Retirement",
                description: "This calculator will show the advantage, if any, of converting your IRA to a Roth."
            },
            {
                name: "Roth IRA Conversion with Distributions",
                url: "/DinkyTown/RothConversion.html",
                category: "Retirement",
                description:
                    "Use this calculator to help determine how you can stretch out your retirement plan distributions for as long as possible."
            },
            {
                name: "Traditional IRA",
                url: "/DinkyTown/RegularIRA.html",
                category: "Retirement",
                description: "How can contributing to a regular IRA help you in your retirement?"
            }           
        ];

        this.mapleLifeCalculatorSso = function() {
            var w = window.open();
            w.document.write(externalLoading.html);
            ssoApi.initiateMapleLifeCalculatorSso().then(function(redirectUrl) {
                console.log(redirectUrl);
                w.location = redirectUrl;
            });
        };

        this.activateIpipelineSso = function(rsid) {
            if (permissionService.hasOnePermission(
                "IpipelineFormsQuotesAnnuity:Access|IpipelineFormsQuotesLife:Access|IpipelineFormsQuotesLtc:Access")) {
                //move window.open() to outside the async api call
                //needs to be in direct response to a user event (click) to not be blocked by popup blockers
                var w = window.open();
                w.document.write(externalLoading.html);
                ssoApi.initiateIpipelineSso(rsid).then(function(data) {
                        //console.log(data);
                        w.document.write(data);
                        w.document.forms.samlform.submit();
                    },
                    function(error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
            }
        };

        $ctrl.logEvent = function (target) {
            amplitudeService.logClickEvent(target);
        };
    }
  
})(window.app); // jshint ignore:line